import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldConfigureRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-configure',
	path: '/secure/admin/ConfigureFieldScreen.jspa',
};
